/**
 * Check if user has admin role
 * @param roles - Array of user roles from federate token
 * @returns true if any role contains "admin" (case-insensitive)
 */
export const isAdminUser = (roles: string[]): boolean => {
  return roles.some((role) => role.toLowerCase().includes('admin'));
};
